import React, { useRef } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendarDays } from '@fortawesome/free-solid-svg-icons'

/**
 * Input tanggal dengan tampilan seragam di semua browser. Ikon kalender bawaan
 * browser disembunyikan lewat CSS (lihat `.date-input` di tailwind.css) dan
 * diganti ikon sendiri.
 *
 * Tingginya h-12, sama dengan tinggi .btn daisyUI, supaya sejajar kalau
 * ditaruh sebaris dengan tombol.
 */
const DateInput = ({
  id,
  name,
  value,
  onChange,
  disabled,
  min,
  max,
  className = '',
}) => {
  const inputRef = useRef(null)

  const openPicker = () => {
    if (disabled) {
      return
    }
    try {
      inputRef.current?.showPicker?.()
    } catch (error) {
      // Sebagian browser melempar kalau picker-nya sudah kebuka. Diabaikan:
      // input-nya tetap bisa diketik manual.
    }
  }

  return (
    <div
      className={`flex items-center gap-2 h-12 px-4 rounded-lg border border-[#E3E6E8] bg-white transition-colors focus-within:border-[#f3790e] ${
        disabled ? 'opacity-60' : 'cursor-pointer'
      } ${className}`}
      onClick={openPicker}
    >
      <FontAwesomeIcon icon={faCalendarDays} className="text-[#838489]" />
      <input
        ref={inputRef}
        id={id}
        name={name}
        type="date"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        min={min}
        max={max}
        className="date-input grow bg-transparent text-sm outline-none disabled:cursor-not-allowed"
      />
    </div>
  )
}

export default DateInput
